@let stroke = strokeWidth$ | async;
    <div class="mat-icon-wrapper" (click)="selectStrokeWidth(5)">
        <img [attr.src]="'assets/icons/svg/stroke-width-1' + (stroke === 5 ? '-selected.svg' : '.svg')"/>
    </div>
    <div class="mat-icon-wrapper" (click)="selectStrokeWidth(10)">
        <img [attr.src]="'assets/icons/svg/stroke-width-2' + (stroke === 10 ? '-selected.svg' : '.svg')"/>
    </div>
    <div class="mat-icon-wrapper" (click)="selectStrokeWidth(20)">
        <img [attr.src]="'assets/icons/svg/stroke-width-3' + (stroke === 20 ? '-selected.svg' : '.svg')"/>
    </div>